module.exports = __webpack_public_path__ + "static/media/4 4 tattoo forearm tyrael archangel celestial heroic ethereal dark.1280x1707.ff7bef35.webp";